module.exports = __webpack_public_path__ + "static/chinaTrademark-22cd7906311575c675b384b33c7d3f61.jpg";